import { ChangeDetectorRef, Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AirdiskbrakeService } from 'src/app/services/feature/airdisk-brake/airdiskbrake.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AirdiskValueDisclaimerComponent } from '../airdisk-value-disclaimer/airdisk-value-disclaimer.component';

@Component({
    selector: 'app-airdisk-vistor-info',
    templateUrl: './airdisk-vistor-info.component.html',
    styleUrls: ['./airdisk-vistor-info.component.scss'],
    standalone: false
})
export class AirdiskVistorInfoComponent {

  private readonly destroy$ = new Subject<void>();
  
  constructor(public airdiskService:AirdiskbrakeService,private readonly cdr:ChangeDetectorRef,private readonly dialog: MatDialog){}

  vistorInfoForm = new FormGroup({
    firstName: new FormControl(null),
    lastName: new FormControl(null),
    eMail: new FormControl(null),
    adbValueCalculatorType: new FormControl("Tractor"),
    valueDisclaimer: new FormControl(false, { validators: Validators.required }),   
  });

  get form() {
    return this.vistorInfoForm.controls;
  }

 

  ngOnInit() {     
  
    this.airdiskService.vistInfoData$.pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      if(data!=null){
        this.vistorInfoForm.patchValue({
          firstName: data.firstName || null,
          lastName: data.lastName || null,
          eMail: data.eMail || null,
          adbValueCalculatorType: data.adbValueCalculatorType || 'Tractor',
          valueDisclaimer: data.valueDisclaimer || false,
        });
      }
     
    })

    this.vistorInfoForm.controls.valueDisclaimer.valueChanges.subscribe(value => {
      this.airdiskService.valueDisclaimer$.next(value);
      this.cdr.detectChanges();
    });  
  }
  storeDataOnChange(){
    
    if(this.vistorInfoForm.valid){
      this.airdiskService.vistInfoData$.next(this.vistorInfoForm.value);
      this.cdr.detectChanges();

      //radio button value
      const selectedOption = this.vistorInfoForm.controls['adbValueCalculatorType'].value;
      this.airdiskService.setSelectedOption(selectedOption);
    }
  }

  endaSureNxt(){  
    this.storeDataOnChange();
    this.airdiskService.currentComponent$.next('fleetInfo');
     
  }
  openDataProtectionDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    const dialogRef = this.dialog.open(AirdiskValueDisclaimerComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((data) => {
      if (data) 
        {this.vistorInfoForm.controls['valueDisclaimer'].patchValue(data);
      this.airdiskService.vistInfoData$.next(this.vistorInfoForm.value);
        }
    });
  }

ngOnDestroy() {
  // Complete the destroy$ subject to unsubscribe all subscriptions
  this.destroy$.next();
  this.destroy$.complete();
}
}
